import { forwardRef } from 'react';
import ReactQuill from 'react-quill-new';

import FQuillEditorBase from './FQuillEditorBase';

import type { FQuillEditorProps, QuillEditorProps } from './types';

import 'react-quill-new/dist/quill.snow.css';

const QuillEditor = forwardRef<ReactQuill, QuillEditorProps>(function QuillEditor(
  { onChange, onBlur, onChangeSelection, onFocus, ...props },
  ref,
) {
  return (
    <ReactQuill
      {...props}
      ref={ref}
      onChange={(value) => onChange?.(value)}
      onBlur={(selection) => onBlur?.(selection)}
      onChangeSelection={(selection) => onChangeSelection?.(selection)}
      onFocus={(selection) => onFocus?.(selection)}
    />
  );
});

const FQuillEditor = forwardRef<HTMLDivElement, FQuillEditorProps>(function FQuillEditor(
  props,
  ref,
) {
  return <FQuillEditorBase {...props} ref={ref} editorComponent={QuillEditor} />;
});

export default FQuillEditor;
